/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState } from 'react';
import apiBackendInstance from '../../../utils/axios';
import BaseUrls from '../../../utils/baseUrls';
import Urls from '../../../utils/urls';
import { cli } from './accessCredential';

interface Data {
  entires: cli[],
  refreshCliList:()=>void
}

const CredentialTable = ({ entires, refreshCliList }: Data) => {
  const theme = BaseUrls.getkey();
  const eyeIcon = `img/${theme}/eye-off.svg`;
  const copyIcon = `img/${theme}/copy.svg`;
  // const deleteIcon = `img/${theme}/deleteicon.svg`;
  const [deleteKey, setDeleteKey] = useState<{id:string;name:string}>({
    name: '',
    id: '',
  });
  const [viewPass, setViewPass] = useState(true);

  const viewPassword = (idx: number, accessKey: string | number) => {
    const ids = `accessKey${idx.toString()}`;
    const pass: HTMLElement | null = document.getElementById(ids);
    if (pass) {
      if (viewPass) {
        pass.innerHTML = accessKey.toString();
      } else {
        pass.innerHTML = '******************************************************';
      }
      setViewPass(!viewPass);
    }
  };

  function copyText(accessKey: string | number) {
    const ptag: HTMLElement | null = document.getElementById('succ');
    if (ptag) {
      ptag.style.display = 'block';
      setTimeout(() => {
        ptag.style.display = 'none';
      }, 1500);
    }

    navigator.clipboard.writeText(accessKey.toString());
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function showModal(mid:string, name:string) {
    setDeleteKey({
      name,
      id: mid,
    });
    const modal: HTMLElement | null = document.getElementById('deleteModal');
    const deleteMsg = document.getElementById('deleteMsg');
    const deleteBtn = document.getElementById('deleteNetworkBtn');
    const deleteBtn2 = document.getElementById('deleteNetworkBtn2');
    const modalHeadingDelete = document.getElementById('modalHeadingDelete');
    const modalStatus = document.getElementById('modalStatus');
    if (modalStatus) {
      modalStatus.style.display = 'none';
    }
    if (modalHeadingDelete) {
      modalHeadingDelete.style.display = 'block';
    }

    if (deleteBtn2) {
      deleteBtn2.style.display = 'block';
    }
    if (deleteMsg) {
      deleteMsg.style.display = 'none';
    }
    if (deleteBtn) {
      deleteBtn.style.display = 'block';
    }
    if (modal) {
      modal.style.display = 'block';
    }
  }

  function deleteApiKeyCred() {
    const deleteBtn = document.getElementById('deleteNetworkBtn');
    const deleteBtn2 = document.getElementById('deleteNetworkBtn2');

    const deleteMsg = document.getElementById('deleteMsg');
    if (deleteBtn) {
      deleteBtn.style.display = 'none';
    }
    if (deleteBtn2) {
      deleteBtn2.style.display = 'none';
    }
    const modalHeadingDelete = document.getElementById('modalHeadingDelete');
    callDeleteApiKeyCredApi(deleteKey.id, deleteKey.name, deleteMsg as HTMLElement, modalHeadingDelete as HTMLElement);
  }

  function callDeleteApiKeyCredApi(apiKey:string, apiKeyName:string, deleteMsg:HTMLElement, modalHeadingDelete:HTMLElement) {
    const spinner = document.getElementById('spinnerDiv');
    const modalStatus = document.getElementById('modalStatus');
    if (spinner) spinner.style.display = 'block';
    apiBackendInstance.delete(Urls.getDeleteApiKeyCredById(apiKey, apiKeyName), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (spinner) spinner.style.display = 'none';
      if (modalHeadingDelete) {
        modalHeadingDelete.style.display = 'none';
      }
      if (modalStatus) {
        modalStatus.style.display = 'block';
      }

      if (response && response.data && response.data.success) {
        deleteMsg.innerHTML = '<span class="text text-info">successfully deleted api key cred</span>';
        deleteMsg.style.display = 'block';
      } else {
        deleteMsg.innerHTML = (response && response.data && response.data.message)
          ? `<span class="text text-danger">there was some problem : ${response.data.message}<span class="text text-danger">`
          : '<span class="text text-danger">there was some problem deleting this api key cred</span>';
        deleteMsg.style.display = 'block';
      }
    }).catch((error) => {
      if (spinner) spinner.style.display = 'none';
      if (modalStatus) {
        modalStatus.style.display = 'block';
      }
      if (modalHeadingDelete) {
        modalHeadingDelete.style.display = 'none';
      }

      deleteMsg.innerHTML = `<span class="text text-danger">there was some problem deleting this api key cred : ${error.message}</span>`;
      deleteMsg.style.display = 'block';
    });
  }

  const hideModal = () => {
    refreshCliList();
    const modal: HTMLElement | null = document.getElementById('deleteModal');
    if (modal) {
      modal.style.display = 'none';
    }
  };
  return (
    <div>
      {entires.length === 0 && (
        <div style={{ color: '#ABB2B9', textAlign: 'center', fontSize: '20px' }}>
          No Data
        </div>
      )}
      <div id="succ" className="alert alert-success mt-3 mb-5" style={{ display: 'none' }} role="alert">Key Copied</div>
      {entires.length > 0 && (
        <table className="table mt-4">
          <thead className="head-bg">
            <tr>
            <th className="col-2">Name</th>
              <th className="col-3 ">Access Key</th>
              <th className="col-1">Action</th>
            </tr>
          </thead>
          <tbody className="tableTextColor">
          {entires.map((d, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={idx.toString()}>
                <td style={{ paddingTop: '.8rem' }}>{d.name}</td>
                <td style={{ paddingTop: '.8rem' }}><p id={`accessKey${idx}`}>**************************************************</p></td>
                <td style={{ paddingTop: '.8rem' }}>
                  <div className="d-flex pt-2">
                  <img
                    src={eyeIcon}
                    height="14px"
                    className="click_effect"
                    title="View Password"
                    alt=""
                    onClick={() => { viewPassword(idx, d.accesskey); }}
                  />
                  <img src={copyIcon} className="mx-3 click_effect" height="14px" title="Copy" alt="" onClick={() => { copyText(d.accesskey); }} />
                  {/* <img src={deleteIcon} className="mx-3 click_effect" height="14px" title="Delete" alt="" onClick={() => { showModal(d.accesskey as string, d.name); }} /> */}
                  </div>
                </td>
              </tr>
          ))}
          </tbody>
        </table>
      )}
      <p
        id="copy"
        style={{
          display: 'none', color: '#ABB2B9', textAlign: 'center', fontSize: '20px',
        }}
      >
        {' '}
        id
      </p>
      <div id="deleteModal" className="workModal text-black" style={{ display: 'none' }}>
        <div className="workModalContent">
          <span
onClick={() => {
  hideModal();
}}
className="closeWork"
          >
&times;
          </span>
            <h6 className="modalHeading mb-4 text-center" id="modalHeadingDelete">
              Are you sure you want to delete
              {' '}
              <strong>
              {deleteKey.name}
              </strong>
              {' '}
              accounts
              ?
            </h6>
            <h6 className="modalHeading mb-4 text-center" id="modalStatus">
              Status
            </h6>
            <p id="deleteMsg" className="mt-3" style={{ display: 'none' }}>
              {`Error Deleting Cloud Cred ${deleteKey.name} `}
            </p>
            <div className="text-center">
                  <button type="button" style={{ margin: 'auto' }} id="deleteNetworkBtn" className="btn comingSoon" onClick={() => { deleteApiKeyCred(); }}>Yes</button>
            </div>
        </div>
      </div>
    </div>
  );
};

export default CredentialTable;
